export default __webpack_public_path__ + "static/media/anjola.0dca68f0.png";